import React, { Component } from 'react'

class CourseTile extends Component {
    state = {  } 
    render() { 

        return (
            <a href={'/courses?course='+ this.props.details.course } style={{textDecoration: 'none' }}><div  className='tileContainer card m-2 p-3' >
             {/* <a href="C:\Users\Owner\Desktop\coding\Registration\createnotice.html"><img class="staff img-fluid w-75" src="images/create a notice.png"/></a> */}
             
               <h1 className='tileTitle'>
                    <b>{this.props.details.course}</b>
                </h1>
               

                <a href={'/refer/'+ this.props.details.course }> 
                {/* <button className="btn btn-info btn-lg  text-white fw-bold"> */}
                    {/* <h5 className='tileTitle'> */}
                   Create Licence for  {this.props.details.course} 
                {/* </h5> */}
                {/* </button> */}
                </a>
            </div>
            </a>
        );
    }
}
 
export default CourseTile;